import React from "react";
import {
  Button,
  Description,
  SubTitle,
} from "../../Components/CustomComponents";
import styles from "./styles/BatchesComponent.module.scss";
import { useEnrollBatchMutation } from "../../Data/services/batchesApi";
import { Spinner } from "react-bootstrap";
import { ErrorToast, SuccessToast } from "../../Hooks/useToast";

const BatchComponent = ({ id, title, image_url, description, is_enrolled = false, onSelect, hasDetailAccess = false }) => {
  const [enrollBatch, { isLoading }] = useEnrollBatchMutation();

  const handleEnrollBatch = async () => {
    try {
      const response = await enrollBatch({ batch_id: id }).unwrap();
      SuccessToast("Batch Enrolled Successfully");
    } catch (err) {
      ErrorToast(err.data?.message);
    }
  }


  return (
    <div className={styles.Batches}>
      <div className={styles.batchCard}>
        <div className="gradientBg p-2 my-2 rounded-4">
          <img
            alt="batch icon"
            src={image_url}
            width={"60px"}
            className="rounded-3"
          />
        </div>
        <SubTitle classes="fs-4 fw-bold" text={title} />
        <Description classes="lc-3 my-1" text={description} />
        {!hasDetailAccess ? "" :
          is_enrolled ?
            <Button
              text="Details"
              classes={`rounded-5 p-2 my-2 fw-bold gradientBg`}
              type="submit"
              onClick={onSelect}
            /> :
            <Button
              text={isLoading ? <Spinner /> : "Enroll Now"}
              classes={`rounded-5 p-2 my-2 fw-bold gradientBg`}
              type="submit"
              onClick={handleEnrollBatch}
            />
        }
      </div>
    </div>
  );
};

export default BatchComponent;
